export default __webpack_public_path__ + "static/media/germ_scientist_badge_small@3x.92c0f834.png";